import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useGroups } from '../contexts/GroupsContext';
import { useHomes } from '../contexts/HomesContext';
import { PageSpinner } from '../components/ui';
import { route } from './paths';

export function HomeRouter() {
  const { user } = useAuth();
  const { homes, loading: homesLoading } = useHomes();
  const { groups, loading: groupsLoading } = useGroups();

  // Wait for homes/groups before deciding where to land — otherwise we route
  // against empty arrays mid-fetch and wrongly send a user with a home to /onboarding.
  if (homesLoading || groupsLoading) {
    return <PageSpinner />;
  }

  // Reached at bare `/home`, which carries no `:homeId` of its own — there is
  // no "current" home to read from the URL, so the first one is the best
  // available choice.
  const selectedHomeId = homes.length > 0 ? homes[0].id : null;

  // New users complete their profile before anything else
  if (user && !user.is_onboarded) {
    return <Navigate to={route('onboarding')} replace />;
  }

  if (selectedHomeId) {
    return <Navigate to={route('homeWorkspace', { homeId: selectedHomeId })} replace />;
  }

  if (groups.length > 0) {
    return <Navigate to={route('groups')} replace />;
  }

  // If user has no homes, send them to experience selection
  return <Navigate to={route('onboarding')} replace />;
}
